module.exports = __webpack_public_path__ + "img/logo_vsl.8947b0ee.png";